import {
  Card, CardContent, CardMedia, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from 'src/assets/images/konsep_2.jpg';
import Page from 'src/components/Page';
import gradients from 'src/utils/gradients';
import LoginForm from './LoginForm';

const meta = document.createElement('meta');
meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
meta.setAttribute('name', 'viewport');
document.head.appendChild(meta);
const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  },
  card: {
    width: theme.breakpoints.values.md,
    maxWidth: '100%',
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  },
  content: {
    padding: theme.spacing(8, 4, 3, 4)
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  icon: {
    backgroundImage: gradients.green,
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: 'absolute',
    top: -32,
    left: theme.spacing(3),
    height: 64,
    width: 64,
    fontSize: 32
  },
  loginForm: {
    marginTop: theme.spacing(3)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  person: {
    marginTop: theme.spacing(2),
    display: 'flex'
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

function Login() {
  const classes = useStyles();
  const { t } = useTranslation('login');
  return (
    <Page
      className={classes.root}
      title={t('Artemis_Giris')}
    >
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          {/* <LockIcon className={classes.icon} /> */}
          <Typography
            gutterBottom
            variant="h3"
          >
            {t('Artemis_Giris')}
          </Typography>
          <Typography variant="subtitle2">
            {t('Giris_Yapiniz')}
          </Typography>
          <LoginForm className={classes.loginForm} />
        </CardContent>
        <CardMedia
          className={classes.media}
          image={logo}
          title="Cover"
        >
          <Typography
            color="inherit"
            variant="subtitle1"
          />
          <div className={classes.person}>
            <div>
              <Typography
                color="inherit"
                variant="body1"
              />
              <Typography
                color="inherit"
                variant="body2"
              />
            </div>
          </div>
        </CardMedia>
      </Card>
    </Page>
  );
}

export default Login;
